<template>
  <div class="min-h-screen bg-white flex flex-col lg:flex-row-reverse">
    <div class="p-4 flex-1 flex flex-col md:p-8 lg:px-20 lg:py-6 lg:max-h-screen lg:overflow-y-auto">
      <div class="flex justify-between items-center mt-4">
        <div class="p-1 mb-2">
          <img src="@/assets/onboarding-logo.svg" alt="ask-a-fundraiser-logo" class="inline-block w-36 mb-auto md:w-40 lg:w-56" :style="{ maxWidth: '180px' }" />
        </div>
      </div>

      <div class="mt-5 flex-1 flex flex-col">
        <div class="success-container">
          <h1 class="font-minion text-[32px] leading-[38.4px] text-[#00423D] font-normal">
            Payment Successful
            <span class="block text-[#00423D] text-[28px] leading-[24px] font-bold mt-0.5 lg:mt-2" style="font-family: 'Open Sans'; font-weight: 700">Let's get your fundraising plan started</span>
          </h1>

          <div class="success-icon">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-16 w-16 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <p class="text-[#666666] text-[14px] leading-[22px] mt-4" style="font-family: 'Open Sans'; font-weight: 400">Thank you for your subscription.</p>
          <p class="text-[#666666] text-[14px] leading-[22px] mt-2" style="font-family: 'Open Sans'; font-weight: 400">
            You will be directed to onboarding in
            <span class="text-[#00423D]"> {{ countdown }}</span> seconds
          </p>
          <router-link to="/onboarding/welcome" class="w-full h-[48px] bg-[#00423D] text-white font-semibold text-[16px] leading-[24px] rounded-[12px] px-6 py-3 mt-6 inline-flex items-center justify-center" style="font-family: 'Open Sans'; font-weight: 600">
            Go to Onboarding
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();
const countdown = ref(30);

const startCountdown = () => {
  const interval = setInterval(() => {
    countdown.value--;
    if (countdown.value === 0) {
      clearInterval(interval);
      redirectToOnboarding();
    }
  }, 1000);
};

const redirectToOnboarding = () => {
  router.push('/onboarding/welcome');
};

onMounted(() => {
  startCountdown();
});
</script>

<style scoped>
.success-container {
  background: #F0F7F6;
  padding: 3rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid #E0E8E7;
}

.success-icon {
  margin: 1.5rem 0;
}

.success-container p {
  max-width: 400px;
  margin: 0 auto;
}

.success-container h1 {
  margin-bottom: 1rem;
}
</style> 